import { Injectable } from "@angular/core"
import { catchError } from "rxjs";
import { APIConfigService } from "../config/api-config";
import { HttpService } from "./http.service";
import { UtilsService } from "./utils.service";



@Injectable({
    providedIn: 'root'
})
export class SignUpService {
    constructor(public utils: UtilsService, private ApiConfig: APIConfigService,
        private httpService: HttpService) { }

    createUser(url: string, payload: { [item: string]: any }, httpOptions: { [item: string]: any }) {
        return this.httpService.post(url, payload, httpOptions);
    }

    sendOtp(url: string, payload: { [item: string]: any }, httpOptions: { [item: string]: any }) {
        return this.httpService.post(url, payload, httpOptions).pipe(catchError(this.utils.processError.bind(this)));;
    }

    verifyOtp(url: string, payload: { [item: string]: any }, httpOptions: { [item: string]: any }) {
        return this.httpService.post(url, payload, httpOptions);

    }
}
